module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "shifts"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', [
    [_c('b-breadcrumb', {
      staticClass: "breadCrumb",
      attrs: {
        "items": _vm.breadCrumbItems
      }
    })]
  ], 2), _vm._v(" "), _c('p', [_vm._v("Here you can set working hours for the "), (!_vm.areaId) ? _c('span', [_vm._v("whole company")]) : _c('span', [_vm._v("area")])]), _vm._v(" "), (_vm.areaId) ? _c('div', [_c('b-form-radio', {
    attrs: {
      "options": _vm.toogleCompanyShiftsOptions,
      "stacked": ""
    },
    model: {
      value: (_vm.toogleCompanyShifts),
      callback: function($$v) {
        _vm.toogleCompanyShifts = $$v
      },
      expression: "toogleCompanyShifts"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "1150px"
    }
  }, [(_vm.toogleCompanyShifts === 1) ? _c('b-table', {
    attrs: {
      "items": _vm.items,
      "fields": _vm.fields,
      "small": ""
    },
    scopedSlots: _vm._u([_vm._l((_vm.fields), function(item, key) {
      return {
        key: key,
        fn: function(data) {
          return [(data.index == _vm.shifts[key].length && !_vm.areaId) ? _c('div', {
            staticClass: "pointer",
            on: {
              "click": function($event) {
                _vm.resetTimes();
                _vm.$refs['modal-' + key][0].show()
              }
            }
          }, [_vm._v("\n          " + _vm._s(_vm.addShiftStr) + "\n\n        ")]) : _vm._e(), _vm._v(" "), (data.index == _vm.shifts[key].length && !_vm.areaId) ? _c('b-modal', {
            ref: 'modal-' + key,
            refInFor: true,
            attrs: {
              "title": "Add shift"
            },
            on: {
              "ok": function($event) {
                return _vm.onClickAddShift(key)
              }
            }
          }, [_c('table', {
            staticClass: "table-border"
          }, [_c('tr', [_c('td', [_vm._v("Enter start time")]), _vm._v(" "), _c('td', [_c('vue-timepicker', {
            attrs: {
              "minute-interval": 5
            },
            model: {
              value: (_vm.timeStart),
              callback: function($$v) {
                _vm.timeStart = $$v
              },
              expression: "timeStart"
            }
          })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("enter end time ")]), _vm._v(" "), _c('td', [_c('vue-timepicker', {
            attrs: {
              "minute-interval": 5
            },
            model: {
              value: (_vm.timeEnd),
              callback: function($$v) {
                _vm.timeEnd = $$v
              },
              expression: "timeEnd"
            }
          })], 1)])])]) : _vm._e(), _vm._v(" "), (data.index < _vm.shifts[key].length) ? _c('span', {
            staticClass: "shift-item"
          }, [_vm._v("\n          " + _vm._s(data.value) + "\n          "), (!_vm.areaId) ? _c('span', {
            staticClass: "hide-button"
          }, [(_vm.authUser.role == 'superuser') ? _c('b-button', {
            staticClass: "btn-edit",
            attrs: {
              "size": "sm",
              "variant": "success"
            },
            on: {
              "click": function($event) {
                _vm.currentItem.key = key;
                _vm.currentItem.index = data.index;
                _vm.makeTimesFromString(data.value);
                _vm.$refs['modal-edit'].show()
              }
            }
          }) : _vm._e(), _vm._v(" "), (_vm.authUser.role == 'superuser') ? _c('b-button', {
            staticClass: "btn-delete",
            attrs: {
              "size": "sm",
              "variant": "danger"
            },
            on: {
              "click": function($event) {
                _vm.currentItem.key = key;
                _vm.currentItem.index = data.index;
                _vm.$refs['modal-delete'].show()
              }
            }
          }) : _vm._e()], 1) : _vm._e()]) : _vm._e()]
        }
      }
    })], null, true)
  }) : _c('b-table', {
    attrs: {
      "items": _vm.itemsArea,
      "fields": _vm.fields,
      "small": ""
    },
    scopedSlots: _vm._u([_vm._l((_vm.fields), function(item, key) {
      return {
        key: key,
        fn: function(data) {
          return [(data.index == _vm.shiftsArea[key].length) ? _c('div', {
            staticClass: "pointer",
            on: {
              "click": function($event) {
                _vm.resetTimes();
                _vm.$refs['modal-area-' + key][0].show()
              }
            }
          }, [_vm._v("\n            " + _vm._s(_vm.addShiftStr) + "\n          ")]) : _vm._e(), _vm._v(" "), (data.index == _vm.shiftsArea[key].length) ? _c('b-modal', {
            ref: 'modal-area-' + key,
            refInFor: true,
            attrs: {
              "title": "Add shift"
            },
            on: {
              "ok": function($event) {
                return _vm.onClickAddShift(key)
              }
            }
          }, [_c('table', {
            staticClass: "table-border"
          }, [_c('tr', [_c('td', [_vm._v("Enter start time")]), _vm._v(" "), _c('td', [_c('vue-timepicker', {
            attrs: {
              "minute-interval": 5
            },
            model: {
              value: (_vm.timeStart),
              callback: function($$v) {
                _vm.timeStart = $$v
              },
              expression: "timeStart"
            }
          })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("enter end time ")]), _vm._v(" "), _c('td', [_c('vue-timepicker', {
            attrs: {
              "minute-interval": 5
            },
            model: {
              value: (_vm.timeEnd),
              callback: function($$v) {
                _vm.timeEnd = $$v
              },
              expression: "timeEnd"
            }
          })], 1)])])]) : _vm._e(), _vm._v(" "), (data.index < _vm.shiftsArea[key].length) ? _c('span', {
            staticClass: "shift-item"
          }, [_vm._v("\n          " + _vm._s(data.value) + "\n          "), _c('span', {
            staticClass: "hide-button"
          }, [(_vm.authUser.role == 'superuser') ? _c('b-button', {
            staticClass: "btn-edit",
            attrs: {
              "size": "sm",
              "variant": "success"
            },
            on: {
              "click": function($event) {
                _vm.currentItem.key = key;
                _vm.currentItem.index = data.index;
                _vm.makeTimesFromString(data.value);
                _vm.$refs['modal-edit'].show()
              }
            }
          }) : _vm._e(), _vm._v(" "), (_vm.authUser.role == 'superuser') ? _c('b-button', {
            staticClass: "btn-delete",
            attrs: {
              "size": "sm",
              "variant": "danger"
            },
            on: {
              "click": function($event) {
                _vm.currentItem.key = key;
                _vm.currentItem.index = data.index;
                _vm.$refs['modal-delete'].show()
              }
            }
          }) : _vm._e()], 1)]) : _vm._e()]
        }
      }
    })], null, true)
  })], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal-edit",
    attrs: {
      "title": "Edit shift"
    },
    on: {
      "ok": function($event) {
        return _vm.onClickEdit(_vm.currentItem.key, _vm.currentItem.index)
      }
    }
  }, [_c('table', {
    staticClass: "table-border"
  }, [_c('tr', [_c('td', [_vm._v("Enter start time")]), _vm._v(" "), _c('td', [_c('vue-timepicker', {
    attrs: {
      "minute-interval": 5
    },
    model: {
      value: (_vm.timeStart),
      callback: function($$v) {
        _vm.timeStart = $$v
      },
      expression: "timeStart"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("enter end time ")]), _vm._v(" "), _c('td', [_c('vue-timepicker', {
    attrs: {
      "minute-interval": 5
    },
    model: {
      value: (_vm.timeEnd),
      callback: function($$v) {
        _vm.timeEnd = $$v
      },
      expression: "timeEnd"
    }
  })], 1)])])]), _vm._v(" "), _c('b-modal', {
    ref: "modal-delete",
    attrs: {
      "title": "Delete shift"
    },
    on: {
      "ok": function($event) {
        return _vm.onClickDelete(_vm.currentItem.key, _vm.currentItem.index)
      }
    }
  }, [_vm._v("\n      Are you sure you want to delete this shift and its contents?\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de6aef3a","hasScoped":false}!./src/components/shifts/shifts.component.html
// module id = 556
// module chunks = 1